import { render, staticRenderFns } from "./CustomerSOP.vue?vue&type=template&id=3c28aa9a&scoped=true&"
import script from "./CustomerSOP.vue?vue&type=script&lang=js&"
export * from "./CustomerSOP.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSOP.vue?vue&type=style&index=0&id=3c28aa9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28aa9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c28aa9a')) {
      api.createRecord('3c28aa9a', component.options)
    } else {
      api.reload('3c28aa9a', component.options)
    }
    module.hot.accept("./CustomerSOP.vue?vue&type=template&id=3c28aa9a&scoped=true&", function () {
      api.rerender('3c28aa9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/CustomerSOP.vue"
export default component.exports